// API Service for SolarBull Website
const API_URL = process.env.REACT_APP_BACKEND_URL;

// Check if backend is configured
const hasBackend = () => !!API_URL;

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'An error occurred' }));
    throw new Error(error.message || 'An error occurred');
  }
  return response.json();
};

// Projects API
export const getProjects = async (type = null) => {
  if (!hasBackend()) throw new Error('No backend configured');
  const url = type && type !== 'All' 
    ? `${API_URL}/api/projects?type=${type}` 
    : `${API_URL}/api/projects`;
  const response = await fetch(url);
  return handleResponse(response);
};

export const getProject = async (id) => {
  if (!hasBackend()) throw new Error('No backend configured');
  const response = await fetch(`${API_URL}/api/projects/${id}`);
  return handleResponse(response);
};

// Services API
export const getServices = async () => {
  if (!hasBackend()) throw new Error('No backend configured');
  const response = await fetch(`${API_URL}/api/services`);
  return handleResponse(response);
};

// Team API
export const getTeam = async () => {
  if (!hasBackend()) throw new Error('No backend configured');
  const response = await fetch(`${API_URL}/api/team`);
  return handleResponse(response);
};

// Testimonials API
export const getTestimonials = async () => {
  if (!hasBackend()) throw new Error('No backend configured');
  const response = await fetch(`${API_URL}/api/testimonials`);
  return handleResponse(response);
};

// FAQs API
export const getFaqs = async () => {
  if (!hasBackend()) throw new Error('No backend configured');
  const response = await fetch(`${API_URL}/api/faqs`);
  return handleResponse(response);
};

// Stats API
export const getStats = async () => {
  if (!hasBackend()) throw new Error('No backend configured');
  const response = await fetch(`${API_URL}/api/stats`);
  return handleResponse(response);
};

// Contact Form API - uses mailto fallback if no backend
export const submitContactForm = async (formData) => {
  if (!hasBackend()) {
    // Fallback: open mailto link so lead is not lost
    const subject = encodeURIComponent(`Solar Enquiry from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nProperty Type: ${formData.propertyType || 'Not specified'}\n\nMessage:\n${formData.message}`
    );
    window.open(`mailto:srini@solarbull.in?subject=${subject}&body=${body}`);
    return { success: true, method: 'mailto' };
  }
  const response = await fetch(`${API_URL}/api/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      property_type: formData.propertyType || null,
      message: formData.message,
    }),
  });
  return handleResponse(response);
};

// Calculator Quote API
export const saveCalculatorQuote = async (quoteData) => {
  if (!hasBackend()) throw new Error('No backend configured');
  const response = await fetch(`${API_URL}/api/calculator/quote`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      property_type: quoteData.propertyType,
      monthly_bill: quoteData.monthlyBill,
      monthly_units: quoteData.monthlyUnits,
      roof_area: quoteData.roofArea || null,
      location: quoteData.location || null,
      name: quoteData.name || null,
      email: quoteData.email || null,
      phone: quoteData.phone || null,
      system_size: quoteData.systemSize,
      total_cost: quoteData.totalCost,
      subsidy: quoteData.subsidy,
      net_cost: quoteData.netCost,
      annual_savings: quoteData.annualSavings,
      payback_period: quoteData.paybackPeriod,
    }),
  });
  return handleResponse(response);
};
